// Autogenerated file
export const logistTaskStatusesEnum = {
    New: "New",
    Viewed: "Viewed",
    Completed: "Completed",
    Canceled: "Canceled",
    Failed: "Failed",
};
export const logistTaskStatuses = [
    { label: "Новый", value: "New" },
    { label: "Просмотрено", value: "Viewed" },
    { label: "Выполнена", value: "Completed" },
    { label: "Отменена", value: "Canceled" },
    { label: "Не выполнена", value: "Failed" },
];
